import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import { FormGroup } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

interface EditFormActionsProps {
  loadingSave: boolean
  onCancel: () => void
}

const EditFormActions: React.FC<EditFormActionsProps> = ({
  loadingSave,
  onCancel
}) => {
  const { t } = useAPPTranslation()

  return (
    <>
      <Loading status={loadingSave}>{t('common:actions.saving')}</Loading>

      <FormGroup className="actionButtons">
        <Button
          type="button"
          template="transparentCritical"
          onClick={onCancel}
          text={t('common:actions.cancel')}
        />

        <Button
          type="submit"
          template="primary"
          loading={loadingSave}
          disabled={loadingSave}
          text={t('common:actions.save')}
          textLoading={t('common:actions.saving')}
        />
      </FormGroup>
    </>
  )
}

export default EditFormActions
